import React, { FunctionComponent as FC, useState } from 'react';

import { Box, Icon, Input, InputElement, InputProps } from '@chakra-ui/react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

interface MPasswordInputProps extends InputProps {}
const MPasswordInput: FC<MPasswordInputProps> = React.forwardRef<
  any,
  MPasswordInputProps
>((props: MPasswordInputProps, ref) => {
  const { ...rest } = props;
  const [keyShow, setKeyShow] = useState(false);
  return (
    <Box position="relative">
      <Input
        size="sm"
        pr="2rem"
        type={keyShow ? 'text' : 'password'}
        {...rest}
      />
      {/* `top`: v3's InputElement only gets a position inside an InputGroup;
          here it would otherwise drop below the input. */}
      <InputElement placement="end" top="0" width="2rem" px="0">
        <Icon
          cursor="pointer"
          color="tGray.lightPurple"
          as={keyShow ? MdVisibility : MdVisibilityOff}
          onClick={() => setKeyShow(!keyShow)}
        />
      </InputElement>
    </Box>
  );
});

export default MPasswordInput;
